import { useEffect, useMemo, useState } from 'react'
import axios from 'axios'
import { REPLACEMENT_STATUSES_DE } from '../constants'
import { isEmpty } from 'lodash'

export const useSwapReplacements = () => {
    const [swapReplacements, setSwapReplacements] = useState([])
    const [swapReplacementsEvents, setSwapReplacementsEvents] = useState([])
    const [currentSwapReplacementId, setCurrentSwapReplacementId] =
        useState(null)
    const [currentSwapReplacement, setCurrentSwapReplacement] = useState(null)
    const [replacementsLocations, setReplacementsLocations] = useState([])
    const [currentReplacementsLocation, setCurrentReplacementsLocation] =
        useState(null)
    const [currentDeviceSerial, setCurrentDeviceSerial] = useState(null)
    const [isOpenQrModal, setIsOpenQrModal] = useState(false)
    const [search, setSearch] = useState('')
    const [isCancelReplacementModalOpen, setIsCancelReplacementModalOpen] =
        useState(false)
    const [userNumberToConfirmCancel, setUserNumberToConfirmCancel] =
        useState('')
    const [isConfirmCancelError, setIsConfirmCancelError] = useState(false)
    const numberToConfirmCancel = useMemo(
        () => Math.floor(Math.random() * (999 - 100 + 1) + 100),
        [isCancelReplacementModalOpen]
    )
    const [filterStatuses, setFilterStatuses] = useState([])

    const statusPickerOptions = Object.keys(REPLACEMENT_STATUSES_DE).map(
        key => ({ key, name: REPLACEMENT_STATUSES_DE[key] })
    )

    const fetchSwapReplacements = async (
        mounted,
        locationId,
        search,
        statuses
    ) => {
        try {
            const params = {
                search
            }
            if (locationId) {
                params.location_id = locationId
            }
            if (!isEmpty(statuses)) {
                params.statuses = statuses.map(s => s.key)
            }
            const data = (
                await axios.get(`${process.env.API_URL}/swap-replacements`, {
                    params
                })
            ).data
            if (mounted) {
                setSwapReplacements(data)
            }
        } catch (ex) {
            // TODO
        }
    }

    const fetchReplacementsLocations = async mounted => {
        try {
            const data = (
                await axios.get(
                    `${process.env.API_URL}/swap-replacements/replacements-locations`
                )
            ).data
            if (mounted) {
                setReplacementsLocations(data)
            }
        } catch (ex) {
            // TODO
        }
    }

    const fetchSwapReplacementsEvents = async (mounted, id) => {
        try {
            const data = (
                await axios.get(
                    `${process.env.API_URL}/swap-replacements/${id}/events`
                )
            ).data
            if (mounted) {
                setSwapReplacementsEvents(data)
            }
        } catch (ex) {
            // TODO
        }
    }

    const cancelSwapReplacement = async id => {
        try {
            await axios.post(
                `${process.env.API_URL}/swap-replacements/cancel-replacement/${id}`
            )
            await refresh()
        } catch (ex) {
            // TODO
        }
    }

    const removeReplacementDevice = async id => {
        try {
            await axios.delete(
                `${process.env.API_URL}/swap-replacements/${id}/replacement-device`
            )
            await refresh()
        } catch (ex) {
            // TODO
        }
    }

    const refresh = async () => {
        await fetchSwapReplacements(
            true,
            currentReplacementsLocation?.id,
            search,
            filterStatuses
        )
        if (currentSwapReplacementId) {
            await fetchSwapReplacementsEvents(true, currentSwapReplacementId)
        }
    }

    const onConfirmReplacementCancel = id => {
        if (Number(userNumberToConfirmCancel) === numberToConfirmCancel) {
            cancelSwapReplacement(id)
            setIsCancelReplacementModalOpen(false)
            setIsConfirmCancelError(false)
        } else {
            setIsConfirmCancelError(true)
        }
    }

    useEffect(() => {
        let mounted = true
        // not needed because of the search useEffect
        // fetchSwapReplacements(mounted, currentReplacementsLocation?.id, search)
        fetchReplacementsLocations(mounted)
        return () => (mounted = false)
    }, [])

    useEffect(() => {
        let mounted = true
        if (currentSwapReplacementId) {
            const currentSR = swapReplacements?.find(
                sr => sr.id === currentSwapReplacementId
            )
            setCurrentSwapReplacement(currentSR)
            fetchSwapReplacementsEvents(mounted, currentSwapReplacementId)
        }
        return () => (mounted = false)
    }, [currentSwapReplacementId])

    useEffect(() => {
        let mounted = true
        // console.log({currentReplacementsLocation})
        fetchSwapReplacements(
            mounted,
            currentReplacementsLocation?.id,
            search,
            filterStatuses
        )
        return () => (mounted = false)
    }, [currentReplacementsLocation, search, filterStatuses])

    /* useEffect(() => {
        let mounted = true
        fetchSwapReplacements(mounted, currentReplacementsLocation?.id, search)
        return () => mounted = false
    }, [search]) */

    useEffect(() => {
        if (!isCancelReplacementModalOpen) {
            setIsConfirmCancelError(false)
            setUserNumberToConfirmCancel('')
        }
    }, [isCancelReplacementModalOpen])

    return {
        swapReplacements,
        swapReplacementsEvents,
        replacementsLocations,
        currentReplacementsLocation,
        setCurrentReplacementsLocation,
        currentDeviceSerial,
        setCurrentDeviceSerial,
        isOpenQrModal,
        setIsOpenQrModal,
        currentSwapReplacementId,
        setCurrentSwapReplacementId,
        currentSwapReplacement,
        refresh,
        search,
        setSearch,
        isCancelReplacementModalOpen,
        setIsCancelReplacementModalOpen,
        onConfirmReplacementCancel,
        numberToConfirmCancel,
        userNumberToConfirmCancel,
        setUserNumberToConfirmCancel,
        isConfirmCancelError,
        statusPickerOptions,
        filterStatuses,
        setFilterStatuses,
        removeReplacementDevice
    }
}
